"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionSendTextMessage = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.JourneyActionSendTextMessage = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.SendTextMessage,
    channels: [enums_1.ChannelEnum.Voice],
    direction: enums_1.JourneyNodeDirectionEnum.InputOutput,
    settings_schema: (0, base_1.settingsValidationSchema)({
        text_message_source_id: {
            type: "number",
            required: true,
        },
        body: {
            type: "string",
            required: true,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_SEND_TEXT_MESSAGE_SUCCESS_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_SEND_TEXT_MESSAGE_SUCCESS_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: false,
                index: 0,
                title: "NEXT",
                color: null,
            }) });
    },
});
